var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tooltip',{attrs:{"slot":"after","placement":"right","overlay-class-name":"outside-config-tooltip"},slot:"after"},[_c('template',{slot:"title"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]),_c('i',{staticClass:"iconfont iconicon-test31 tooltip-btn"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }